import { MarkerModel } from "./marker.model";
import { ProductModel } from "./product.model";
import { NurseryModel } from "./nursery.model";

export class PhotosphereModel {
    public uuid: string;
    public name: string;
    public yaw: number;
    public mediaURL: string;
    public markers: MarkerModel[];
    public products: ProductModel[];
    public latitude: number;
    public longitude: number;
    public nurseryUuid: string;
    public nursery: NurseryModel;

    constructor(value: JSON) {
        this.uuid = value["uuid"];
        this.name = value["name"];
        this.yaw = value["yaw"];
        this.latitude = value["latitude"];
        this.longitude = value["longitude"];
        this.nurseryUuid = value["nursery_uuid"];
        if(value["markers"]) {
            this.markers = [];
            for(const marker of value["markers"]) {
                this.markers.push(new MarkerModel(marker));
            }
        }
        if(value["products"]) {
            this.products = [];
            for(const product of value["products"]) {
                this.products.push(new ProductModel(product));
            }
        }
        if(value["nursery"]) {
            this.nursery = new NurseryModel(value["nursery"]);
        }
    }
}
